var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { useEventHandlers } from "./useEventHandlers";
export function useObserver(_a) {
    var { initOptions, ObserverClass, onEvents } = _a, props = __rest(_a, ["initOptions", "ObserverClass", "onEvents"]);
    const target = props.target;
    const onUpdate = props.onUpdate;
    const observer = React.useMemo(() => {
        return new ObserverClass(onUpdate);
    }, [ObserverClass, onUpdate]);
    React.useEffect(function observeRealElement() {
        if (!target || !observer)
            return;
        observer.observe(target, initOptions);
        return function destroy() {
            observer.disconnect();
        };
    }, [initOptions, observer, onUpdate, target]);
    const handlers = React.useMemo(() => {
        return Array.from(onEvents !== null && onEvents !== void 0 ? onEvents : []).map((eventType) => [eventType, onUpdate]);
    }, [onEvents, onUpdate]);
    useEventHandlers(target, handlers);
}
